<template>
        <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                    <div class="row align-items-center py-4">
                        <div class="col-lg-5 col-md-12 mb-4">
                            <h2>Support Data</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
        <div class="container-fluid mt--6 filter-show">
            <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="row">
              <div class="col-lg-6">
                <form class="row" @submit.prevent="">
                    <div class="col-md-2 col-lg-9">
                      <label for="filter" class="col-form-label">CUSIP</label>
                      <input max="9" v-model="searchVal" v-on:keyup.enter="getCusipList" class="form-control" placeholder=""/>
                    </div>
                    <div class="col-md-3 mt-2 tbl-sch col-lg-3 input-group" style="top: 36px">
                        <button @click="getCusipList()" type="button" class="btn btn-success rounded arbs-btn">
                            <i  class="fa fa-search"></i>
                            Search 
                        </button>
                    </div>
                </form>
              </div>
            </div>
          </div>
        </div>
    </div>   
    
    <div class="container-fluid" >
            <div class="row">
                 <div class="col-xl-12">
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                    <div class="card" id="scroll" style="min-height: 130px;">
                        <SupportData
                            v-bind:bidwanted="cusipData"
                            v-if="supportDataModalOpen"
                            @close="toggleSupportDataModal()"
                        />
                        <div v-if="!cusipData && !loading" class="no-results-found">
                            <h3 class="no-data">No results found</h3>
                        </div>
                     </div>
                     
                 </div>
            </div>
     </div> 
    
    </div>  
                  
     
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import SupportData from "./autobidlist/SupportDataModal.vue";
export default {
  name: "imsCusipComponent",
  components : {
    SupportData,
    
  },
  data() {
    return {
        loading : false,
        searchVal : "",
        cusipData : null,
        supportDataModalOpen : false,
    };
  },
  methods: {
    getCusipList() {
        if (!this.searchVal) {
            this.$alert("Cusip is required.","","error");
            return false;
        }
        if (this.searchVal.length != 9) {
            this.$alert("Enter 9 digit characters long  CUSIP","","error");
            return false;
        }
        this.loading = true;
        const auth = {
            headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/cusip/list?page=1&size=10&cusip="+this.searchVal +"&status=ACTIVE,BLOCKED&sortColumn=cusip&sortOrder=ASC&type=BID",
                auth
            )
            .then(result => {
                this.loading = false;
                if(result.data.content.length == 0){
                    this.$alert("No result found","","warning");
                    this.supportDataModalOpen = false;
                    this.cusipData = null;
                    return false;
                }
                if(result.data.content[0].status  == "BLOCKED"){
                  this.$alert("This CUSIP is blocked","","warning");
                  this.supportDataModalOpen = false;
                  this.cusipData = null;
                  return false;
                }
                this.cusipData = result.data.content[0];
                this.cusipData.cusipId = this.cusipData.id;
                this.supportDataModalOpen = true
                
            })
            .catch(e => {
            console.log("Error", e);
            //self.loading = false;
            });
    },
  },
  mounted() {
    
  }
};
</script>
<style scoped>
.no-data {
  color: #8898aa!important;
}
.no-results-found {
  position: absolute;
  right: 50%;
  top: 50%;
}
</style>